// ============================================================================
// UNIVERSAL ACTION HANDLERS - CRUD ACTIONS
// ============================================================================

import type { UniversalActionHandlers } from "./types";

/**
 * Standard CRUD Actions
 */
export const standardCrudActions: UniversalActionHandlers = {
  // View details action - navigates to the entity's detail page
  viewDetails: async (item, context) => {
    if (!item.id) {
      context.onToast("Cannot navigate: item ID is missing", "error");
      return;
    }
    // Navigate to the entity's detail page
    // The entityName should be available in the context
    const entityName = context.entityName || "items";
    context.onNavigate(`/${entityName}/${item.id}`);
  },

  // Edit action - opens edit modal
  openEditModal: async (item, context) => {
    context.onOpenModal("edit");
  },

  // Delete action - confirms and deletes item
  deleteItem: async (item, context) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      await context.onDeleteItem();
    }
  },

  // Delete entity action - alias for deleteItem (for backward compatibility)
  deleteEntity: async (item, context) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      await context.onDeleteItem();
    }
  },

  // Duplicate action - navigates to create page with duplicate parameter
  duplicateItem: async (item, context) => {
    const entityName = context.entityName || "items";
    context.onNavigate(`/${entityName}/create?duplicate=${item.id}`);
  },

  // Copy link action - copies current URL to clipboard
  copyLink: async (item, context) => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      context.onToast("Link copied to clipboard", "success");
    } catch (error) {
      context.onToast("Failed to copy link", "error");
    }
  },
};
